
import { LoaderFunction } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import {
    AdminPanelPaginatedTagLoaderData
} from "@/routes/adminPanel/tags/main/types/adminPanelPaginatedTagLoaderData.ts";

export const adminPanelTagLoader: LoaderFunction = async ({ request }): Promise<AdminPanelPaginatedTagLoaderData> => {
    const url = new URL(request.url);
    const page = parseInt(url.searchParams.get("page") || "1");
    const search = url.searchParams.get("search") || "";
    const limit = 10; // Sayfa başına öğe sayısı

    try {
        // API endpoint'inizin pagination ve search parametrelerini desteklediğini varsayıyorum
        const response = await apiEndpoints.getTags({
            pageNumber: page,
            pageSize: limit,
            search: search,
            desc: false,
            orderBy: "Title"
        });

        return {
            tags: response.data.items || response.data,
            totalPages: response.data.totalPageCount,
            currentPage: page,
            totalItems: response.data.totalItemCount
        };
    } catch (error) {
        console.error("Tags loading error:", error);
        return {
            tags: [],
            totalPages: 1,
            currentPage: 1,
            totalItems: 0
        };
    }
};